// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from '@firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDVRFEFNQfbW2RCR-ffUcdmnuY5h8V0LBc",
  authDomain: "elposracionalista-36b59.firebaseapp.com",
  projectId: "elposracionalista-36b59",
  storageBucket: "elposracionalista-36b59.appspot.com",
  messagingSenderId: "653479162245",
  appId: "1:653479162245:web:b1fded67d488f038dbd4ec"
};
// const firebaseConfig = {
//   apiKey: "AIzaSyBoLh31x23DHJCIv-3AXbSnaSHzmPFicLs",
//   authDomain: "posraapp-prueba.firebaseapp.com",
//   projectId: "posraapp-prueba",
//   storageBucket: "posraapp-prueba.appspot.com",
//   messagingSenderId: "1040160348738",
//   appId: "1:1040160348738:web:7061a6b7ced902dfb6ebdb"
// };
// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const auth = getAuth(app);

export const provider = new GoogleAuthProvider();